import React, {useRef} from 'react';
import styles from './full-body.module.css';
import useInitialfocus from '../../menu/focus';

function FullBody({fullCaption}) {
  const {fullBody} = styles;
  const mainRef = useRef(null);
  useInitialfocus(mainRef);

  return (
    <div ref={mainRef} tabIndex="-1" className={fullBody}>
      <span>{fullCaption}</span>
    </div>
  );
}

export default FullBody;
